// extracted by mini-css-extract-plugin
export var hero = "XfIOzDQ6Y2jz9w8q_0n5";
export var root = "f0i_QuvmgYWJGJrn0YT_";
export var title1 = "IAYqfygDyVBkbo1vWSGu";
export var title2 = "HDHKqO9FNEk5QyPWq0Iu";
export var title3 = "ivviCPzITBim3SK8kQLB";